import React, { memo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Trans } from 'react-i18next';

const DEFAULT_TOOLTIP_TARGET = <span className="badge warning-color mouse-pointer">?</span>;

const TooltipComponent = memo(({ t, i18nKey, tParams, title, placement = 'right', className = '', children }) => {
  const finalTitle = !!t ? (
    <Trans t={t} i18nKey={i18nKey}>
      {tParams}
    </Trans>
  ) : (
    title
  );
  const tooltipTarget = !!children ? children : DEFAULT_TOOLTIP_TARGET;

  return (
    <Tooltip
      arrow
      title={finalTitle}
      placement={placement}
      className={`react-tooltip ${className ? className : ''}`}
      PopperProps={{
        popperOptions: {
          modifiers: {
            flip: { enabled: false },
            offset: {
              enabled: true,
              offset: '0,10',
            },
            preventOverflow: {
              boundariesElement: 'viewport',
            },
          },
          placement,
        },
        keepMounted: true,
      }}>
      {tooltipTarget}
    </Tooltip>
  );
});

export default TooltipComponent;